module.exports = __webpack_public_path__ + "img/sHoney888_350x350.30c737f6.jpg";